import { render, staticRenderFns } from "./DrillPenMath.vue?vue&type=template&id=bb73f90c&scoped=true&lang=pug&"
import script from "./DrillPenMath.vue?vue&type=script&lang=ts&"
export * from "./DrillPenMath.vue?vue&type=script&lang=ts&"
import style0 from "./DrillPenMath.vue?vue&type=style&index=0&id=bb73f90c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb73f90c",
  null
  
)

export default component.exports